import { createFileRoute } from "@tanstack/react-router"
import Component from "./-components/component"

export const Route = createFileRoute("/(app)/_layout/patients/")({
  component: Component,
})
